import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import { brandPayment } from 'src/services/brandPaymentService';
import { CommonHelper } from 'src/utils/commonHelper';
import { LocalStorage } from 'src/utils/storage/local-storage';

export default function BrandBillingGuard({ children }) {
  const location = useLocation();
  const brand = CommonHelper.GetCurrentBrandId();
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  const exempt = /^(\/brand-payment\/|\/brand-checkout\/|\/login|\/no-brand|\/no-organization)/.test(location.pathname);
  const access = CommonHelper.GetBrandBillingAccess(brand);
  const skip = exempt || !brand || !LocalStorage.getItem('token') || !access.enabled || access.canManage;
  const fetchStatus = !skip && access.canPay;
  useEffect(() => {
    let active = true;
    setResult(null);
    setError('');
    if (fetchStatus)
      brandPayment
        .status(brand)
        .then((data) => {
          if (active) setResult({ brand, path: location.pathname, data });
        })
        .catch((e) => {
          if (active) setError(e.message);
        });
    return () => {
      active = false;
    };
  }, [brand, location.pathname, fetchStatus, retry]);
  if (skip) return children;
  if (!access.canPay) {
    if (access.accessAllowed) return children;
    return (
      <Box p={4}>
        <Alert severity="info">Payment is required. Contact your brand administrator.</Alert>
        <Button onClick={CommonHelper.Logout}>Logout</Button>
      </Box>
    );
  }
  if (error)
    return (
      <Box p={4}>
        <Alert severity="error">{error}</Alert>
        <Button onClick={() => setRetry((n) => n + 1)}>Retry billing check</Button>
        <Button onClick={CommonHelper.Logout}>Logout</Button>
      </Box>
    );
  if (!result || result.brand !== brand || result.path !== location.pathname)
    return (
      <Box p={4}>
        <CircularProgress aria-label="Checking brand subscription" />
      </Box>
    );
  if (!result.data.access_allowed) return <Navigate replace to={`/brand-payment/${brand}`} />;
  return children;
}
